var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Prop, Component, Watch, Mixins } from 'vue-property-decorator';
import ValidationErrorsControl from '@/common/components/ValidationErrorsControl.vue';
import { Savable } from '../mixins/Savable';
var ValidationErrors = /** @class */ (function (_super) {
    __extends(ValidationErrors, _super);
    function ValidationErrors() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * wasInvalid serves as a 'guard bit' for clearing section validation errors.
         * The invalid flag must have first been set before any clearing can be done (or should be needed).
         *
         * This was needed to workaround the timing issues related to setting internal state, running vee-validations and determining
         * whether validation errors should be cleared or not. This issue stems from our unablity to detect the state
         * of the validation observer robustly.
         **/
        _this.wasInvalid = false;
        return _this;
    }
    ValidationErrors.prototype.onState = function (newVal) {
        if (newVal.invalid) {
            this.wasInvalid = true;
        }
        else if (this.wasInvalid) {
            if (this.$route.meta.usePeriods) {
                var periodId = this.$store.getters["vuexPageModule/period"];
                if (this.$route.meta.useMonths) {
                    var monthId = this.$store.getters["vuexPageModule/month"];
                    this.$store.dispatch("vuexPageModule/clearMonthValidationErrors", { month: monthId, period: periodId, section: this.section });
                }
                else {
                    this.$store.dispatch("vuexPageModule/clearPeriodValidationErrors", { period: periodId, section: this.section });
                }
            }
            else {
                this.$store.dispatch("vuexPageModule/clearSectionValidationErrors", this.section);
            }
            this.wasInvalid = false;
        }
    };
    Object.defineProperty(ValidationErrors.prototype, "section", {
        /**
         * Current section identifier. Throws if the current route does not have 'section' meta data.
         **/
        get: function () {
            var temp = this.$route.meta.section;
            if (temp === undefined)
                throw new Error("Route " + this.$route.path + " has no 'section' meta data");
            return Number(temp);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValidationErrors.prototype, "showValidationErrors", {
        get: function () {
            var procurationRequiredView = this.$router.currentRoute.meta.procurationRequired;
            // show validation errors if current route requires procuration and current user does not have procuration even if current view is locked (special validation error message)
            return !this.isReadOnly || (!this.hasProcuration && procurationRequiredView);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValidationErrors.prototype, "hasProcuration", {
        get: function () {
            return this.$store.state.vuexPageModule.currentUser.hasProcuration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValidationErrors.prototype, "validationErrors", {
        /**
         * Gets the current section validation errors
         **/
        get: function () {
            var sectionNumber = this.section;
            var validationErrors = this.$store.getters["vuexPageModule/sectionValidationErrors"](sectionNumber);
            if (this.$route.meta.usePeriods) {
                var periodId_1 = this.$store.getters["vuexPageModule/period"];
                validationErrors = validationErrors.filter(function (x) { return x.periodId == periodId_1; });
                if (this.$route.meta.useMonths) {
                    var monthId_1 = this.$store.getters["vuexPageModule/month"];
                    validationErrors = validationErrors.filter(function (x) { return x.monthId == monthId_1; });
                }
            }
            return validationErrors;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValidationErrors.prototype, "hasValidationErrors", {
        get: function () {
            return this.validationErrors != null && this.validationErrors.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], ValidationErrors.prototype, "state", void 0);
    __decorate([
        Watch('state', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ValidationErrors.prototype, "onState", null);
    ValidationErrors = __decorate([
        Component({
            name: "ValidationErrors",
            components: {
                ValidationErrorsControl: ValidationErrorsControl
            }
        })
    ], ValidationErrors);
    return ValidationErrors;
}(Mixins(Savable)));
export default ValidationErrors;
